import { render } from "./NewsArticle.vue?vue&type=template&id=87f20688&scoped=true"
import script from "./NewsArticle.vue?vue&type=script&lang=js"
export * from "./NewsArticle.vue?vue&type=script&lang=js"

import "./NewsArticle.vue?vue&type=style&index=0&id=87f20688&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f20688"]])

export default __exports__